import { TCmsMedia } from '../models/flow.ts';

export const MEDIA_POPULATE = { media: ['filename'] };

// images-p is the imgix source in front of the Payload media store. There is one store for
// every environment (images-p.casumotest.com is a CNAME to the same Bunny pull zone)
const MEDIA_CDN = 'https://images-p.casumo.com/media';

// imgix ignores the image params on video; fm=mp4 re-encodes it with imgix video (H.264,
// auto quality), which shrinks uncompressed uploads (1.26 MB -> 644 KB for the welcome video)
const VIDEO_FILE = /\.(mp4|m4v|mov|webm)$/i;

const IMAGE_PARAMS = 'auto=compress,format';

const VIDEO_PARAMS = 'fm=mp4';

export const resolveMediaUrl = (media?: TCmsMedia): string => {
  const filename = media?.filename;

  if (!filename) {
    return '';
  }

  const params = VIDEO_FILE.test(filename) ? VIDEO_PARAMS : IMAGE_PARAMS;

  return `${MEDIA_CDN}/${encodeURIComponent(filename)}?${params}`;
};
